<aura-edit-wrapper
  title="Réseaux professionnels & Liens web"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  [showDivider]="true"
  (saved)="onSave($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <etxe-agent-social-links-form
      [links]="currentSocialLinks()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <etxe-agent-social-links-display [socialLinks]="currentSocialLinks()" />
  }
</aura-edit-wrapper>
